module.exports = __webpack_public_path__ + "img/icon-enterprise-gray.21f7cf53.svg";